import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { toFormData } from '../../utils/formUtils';

export default {
  load(type) {
    const url = formUrl(`api/v1/admin/task_schedules`);
    return FetchHelpers.get(url, { type });
  },
  update(taskScheduleId, params) {
    const url = formUrl(`/api/v1/admin/task_schedules/${taskScheduleId}`);
    return FetchHelpers.put(url, params);
  },

  delete(taskScheduleId) {
    const url = formUrl(`/api/v1/admin/task_schedules/${taskScheduleId}`);
    return FetchHelpers.delete(url);
  },
};
